import React, { memo, useCallback } from 'react';

import { DateTimeService } from 'src/services/DateTimeService';

import { ILoyaltyBonusOperation } from '../interfaces';

export interface RowProps {
  operation: ILoyaltyBonusOperation;
  showOperation(operation: ILoyaltyBonusOperation): void;
}

export const Row = memo<RowProps>(({ operation, showOperation }) => {
  const onClick = useCallback(() => showOperation(operation), [operation, showOperation]);

  return (
    <tr key={operation.id} onClick={onClick}>
      <td>{operation.typeText}</td>
      <td>{operation.reasonText || '–'}</td>
      <td>{operation.description || '–'}</td>
      <td>{operation.amount}</td>
      <td>{operation.createdAt && DateTimeService.format(operation.createdAt)}</td>
      <td>{operation.author?.name && operation.author.name}</td>
    </tr>
  );
});
